import PortalPageBox from "@portal/components/atoms/portalPageBox";
import Typography from "@portal/components/atoms/v2/typography";
import Link from "next/link";
import { Fragment, ReactNode } from "react";

interface Props {
  suitabilityReport: string[];
  header: string;
}

const mapHttpsWordsToLinks = (text: string): ReactNode[] =>
  text.split(/(\s+)/).map((word, index) => {
    if (!word.startsWith("https://")) {
      return word;
    }

    const match = word.match(/^(https:\/\/[^\s),.!?;:]+)([),.!?;:]*)$/);
    const href = match?.[1] ?? word;
    const trailing = match?.[2] ?? "";

    return (
      <Fragment key={`link-${index}`}>
        <Link href={href} target="_blank" rel="noopener noreferrer" className="text-blueHighlighted underline">
          {href}
        </Link>
        {trailing}
      </Fragment>
    );
  });

/**
 * Component to display the suitability report after the savings robot is carried out.
 * @param interface
 * @returns the array of text from the report, spread out with spacing.
 */
export const SuitabilityReport = ({ suitabilityReport, header }: Props) => (
  <PortalPageBox className="flex flex-col mt-2">
    <Typography variant="Lead">{header}</Typography>
    <div className="flex flex-col">
      {suitabilityReport.map((item, index) => (
        <div key={index} className="flex mb-2.5">
          <Typography>{mapHttpsWordsToLinks(item)}</Typography>
        </div>
      ))}
    </div>
  </PortalPageBox>
);
